<h2 mat-dialog-title>Gestión de {{'UnidadFuncional' | translate}}</h2>

<div mat-dialog-content>

  <mat-expansion-panel [expanded]="true">

    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div fxLayout="row stretch" fxLayout.xs="column">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>
    </div>

    <form [formGroup]="formGroup" *ngIf="!isValidating && item != null">

      <div fxLayout="row stretch" fxLayout.xs="column">

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Código*</mat-label>
            <input matInput formControlName="Codigo" (keyup.enter)="onSearch()" maxlength="100">
            <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
              {{ getErrorCodigo() }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Número*</mat-label>
            <input matInput type="number" formControlName="Numero" (keyup.enter)="onGuardar()">
            <mat-error *ngIf="!formGroup.controls['Numero'].valid && formGroup.controls['Numero'].touched">
              {{ getErrorNumero() }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Número Partida</mat-label>
            <input matInput formControlName="NumeroPartida" (keyup.enter)="onGuardar()" maxlength="100">
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label *ngIf="!isTipoUnidadSearching">Tipo Unidad*</mat-label>
            <mat-label *ngIf="isTipoUnidadSearching">Cargando...</mat-label>
            <mat-select formControlName="TipoUnidad" (selectionChange)="onTipoUnidadSelect($event)">
              <mat-option *ngFor="let s of tipoUnidadList" [value]="s">{{s.Nombre}}</mat-option>
            </mat-select>
            <mat-error *ngIf="!formGroup.controls['TipoUnidad'].valid && formGroup.controls['TipoUnidad'].touched">
              {{ getErrorTipoUnidad() }}
            </mat-error>
          </mat-form-field>
        </div>

        <ng-container *ngIf="showComunidad">
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
              <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
              <mat-select formControlName="ComunidadId">
                <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Número Piso</mat-label>
              <input matInput type="number" formControlName="NroPiso" (keyup.enter)="onGuardar()">
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="!showComunidad && tenantFeatureFlags?.HabilitarGestionConsorcio">
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isConsorcioSearching">Consorcio*</mat-label>
              <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
              <mat-select formControlName="ConsorcioId">
                <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          </div>
        </ng-container>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>M² Cubiertos</mat-label>
            <input matInput type="number" formControlName="MetrosCuadradosCubiertos" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>M² Descubiertos</mat-label>
            <input matInput type="number" formControlName="MetrosCuadradosDescubiertos" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Cantidad Ambientes</mat-label>
            <input matInput type="number" formControlName="CantidadAmbientes" type="number" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%" >
            <mat-label>Fecha Entrega</mat-label>
            <input matInput [matDatepicker]="fechaEntregaPicker" formControlName="FechaEntrega"  (click)="fechaEntregaPicker.open()">
            <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEntregaPicker">
            </mat-datepicker-toggle>
            <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaEntrega')">
              <mat-icon matDatepickerToggleIcon>clear</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #fechaEntregaPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%" >
            <mat-label>Fecha Escrituración</mat-label>
            <input matInput [matDatepicker]="fechaEscrituracionPicker" formControlName="FechaEscrituracion"  (click)="fechaEscrituracionPicker.open()">
            <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEscrituracionPicker">
            </mat-datepicker-toggle>
            <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaEscrituracion')">
              <mat-icon matDatepickerToggleIcon>clear</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #fechaEscrituracionPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label *ngIf="!isMonedaSearching">Moneda</mat-label>
            <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
            <mat-select formControlName="MonedaId">
              <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Precio</mat-label>
            <input matInput type="number" formControlName="Precio" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Valuación Fiscal</mat-label>
            <input matInput type="number" formControlName="ValuacionFiscal" (keyup.enter)="onGuardar()">
          </mat-form-field>
        </div>

        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Observaciones</mat-label>
            <input matInput formControlName="Observaciones" (keyup.enter)="onGuardar()" maxlength="300">
            <mat-error *ngIf="!formGroup.controls['Observaciones'].valid && formGroup.controls['Observaciones'].touched">
              {{ getErrorObservaciones() }}
            </mat-error>
          </mat-form-field>
        </div>

      </div>

    </form>

  </mat-expansion-panel>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
    <button mat-raised-button color="warn" (click)="onCancel()" class="zb-button">Cancelar</button>
  </div>
</div>
